import moment from 'moment-timezone'

// GGGG-WW-E parst ISO-Wochenjahr, ISO-Woche und ISO-Wochentag direkt. Der frühere
// Weg über moment(String(year)) ging von Januar 1 aus und verschob dann relativ um
// (week - isoWeek()) Wochen — gehörte der 1. Januar noch zur KW 52/53 des Vorjahres
// (z.B. 01.01.2027 = Fr, KW 53/2026), landete das Ergebnis ein Jahr zu früh.
const getIsoWeekDay = (week, year, isoWeekday) =>
    moment(`${year}-${String(week).padStart(2, '0')}-${isoWeekday}`, 'GGGG-WW-E')

// Kinowoche: Donnerstag bis Mittwoch
export const getFromWeekCinemaStartDate = (week, year) => getIsoWeekDay(week, year, 4)

export const getFromWeekCinemaEndDate = (week, year) => getIsoWeekDay(week, year, 3).add(7, 'days')
